module.exports = __webpack_public_path__ + "static/media/rodape.ffa30816.jpg";